var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-option flex-column",class:{'z-crt': _vm.selected}},[_c('h5',[_vm._v(_vm._s(_vm.name))]),_vm._l((_vm.info),function(item,i){return _c('p',{key:i},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }